import { useEffect, useState } from 'react';

export const useIsMobile = (breakpoint = 768) => {
  const getMatches = () => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
  };

  const [isMobile, setIsMobile] = useState(getMatches);

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (e) => setIsMobile(e.matches);
    try {
      media.addEventListener('change', onChange);
    } catch (e) {
      // Safari fallback
      media.addListener(onChange);
    }
    return () => {
      try {
        media.removeEventListener('change', onChange);
      } catch (e) {
        media.removeListener(onChange);
      }
    };
  }, [breakpoint]);

  return isMobile;
};


